<template>
  <div class="oy-center-container">
    <div class="personal-center-container">
      <section class="personal-center">
        <nav class="personal-center__nav"
             ref="personalCenterNav">
          <ul class="personal-center__nav-list">
            <!-- <router-link @click.native="setActive" to="/personalCenter/myLoan" tag="li"
                         :class="['personal-center__nav-list-item--my-loan', $route.meta.name === 'myLoan' ? 'active' : '']">
              我的信贷
            </router-link> -->
            <router-link @click.native="setActive"
                         to="/personalCenter/myLoan_bl"
                         tag="li"
                         :class="['personal-center__nav-list-item--my-loan_bl', $route.meta.name === 'myLoan_bl' ? 'active' : '']">
              我的保理
              <i v-if="this.singleCount||this.payCount > 0" class="red-point"></i>
              
            </router-link>
            <router-link @click.native="setActive"
                         to="/loanDetail_bl_pool"
                         tag="li"
                         :class="['personal-center__nav-list-item--my-loan_bl', $route.meta.name === 'loanDetail_bl_pool' ? 'active' : '']">
              池保理
            </router-link>            
            <keep-alive>
              <router-link v-if="$route.meta.keepAlive"
                           @click.native="setActive"
                           to="/personalCenter/myBill"
                           tag="li"
                           :class="['personal-center__nav-list-item--my-bill', $route.meta.name === 'myBill' ? 'active' : '']">
                我的凭证
              <!-- <i class="red-point"></i> -->
              </router-link>
            </keep-alive>
            <router-link v-if="!$route.meta.keepAlive"
                         @click.native="setActive"
                         to="/personalCenter/myBill"
                         tag="li"
                         :class="['personal-center__nav-list-item--my-bill', $route.meta.name === 'myBill' ? 'active' : '']">
              我的凭证
              <!-- <i class="red-point"></i> -->
            </router-link>
            <!-- <router-link 
                         @click.native="setActive"
                         to="/personalCenter/mainProjectContractList"
                         tag="li"
                         :class="['personal-center__nav-list-item--contract', $route.meta.name === 'mainProjectContractList' ? 'active' : '']">
                合同列表
              <i class="red-point"></i>
            </router-link> -->
            <el-col class="hover-col">
    <el-menu
      default-active="2"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-location"></i>
          <span tag="li"
                style="margin-left:2px;"  :class="['personal-center__nav-list-item--contract', $route.meta.name === 'mainProjectContractList' ? 'active' : '']">合同列表</span>
                <i v-if="this.mainCount||this.singleCount > 0" class="red-point"></i>
        </template>
       
            
          <el-menu-item index="1-1" style="padding-right: 0px;">
            <router-link 
                         @click.native="setActive"
                         to="/personalCenter/mainProjectContractList"
                         tag="li"
                         :class="['personal-center__nav-list-item--contract2', $route.meta.name === 'mainProjectContractList' ? 'active' : '']"
                         style="padding-left: 80px;"
                        >
                保理主合同
              <i v-if="this.mainCount > 0" class="red-point"></i>
            </router-link>
          </el-menu-item>

          <el-menu-item index="1-2" style="padding-right: 0px;">
            <router-link 
                @click.native="setActive"
                to="/personalCenter/blLoanContract/list"
                tag="li"
                :class="['personal-center__nav-list-item--contract2', $route.meta.name === 'blLoanContract' ? 'active' : '']"
                style="padding-left: 80px;" >
                单笔业务合同
              <i v-if="this.singleCount > 0" class="red-point"></i>
            </router-link>
          </el-menu-item>
                
      </el-submenu>
    </el-menu>
  </el-col>
            <router-link @click.native="setActive"
                         to="/personalCenter/transferAdvice/list"
                         tag="li"
                         :class="['personal-center__nav-list-item--contract', $route.meta.name === 'transferAdvice' ? 'active' : '']">
              应收账款转让通知书
              <!-- <i class="red-point"></i> -->
            </router-link>
            <router-link @click.native="setActive"
                         to="/personalCenter/repoNotice/list"
                         tag="li"
                         :class="['personal-center__nav-list-item--contract', $route.meta.name === 'repoNotice' ? 'active' : '']">
              项目回购通知书
              <!-- <i class="red-point"></i> -->
            </router-link>
            <router-link v-if="Number(userInfo.crmCustomerType)" @click.native="checkRealNameAuth" to="/personalCenter/myInfo"
                         tag="li"
                         class="personal-center__nav-list-item--my-info">
              <span v-if="Number(userInfo.crmCustomerType) === 1">
                个人信息
                <!-- <i class="red-point"></i> -->
              </span>
              <span v-if="Number(userInfo.crmCustomerType) === 2">
                企业信息
                <!-- <i class="red-point"></i> -->
              </span>
            </router-link>
            <router-link @click.native="checkRealNameAuth" to="/personalCenter/bankcardInfo"
                         tag="li"
                         class="personal-center__nav-list-item--bankcard-info"
                         :class="['personal-center__nav-list-item--my-loan', $route.meta.name === 'bankcardInfo' ? 'active' : '']">
              银行账户信息
              <!-- <i class="red-point"></i> -->
            </router-link>
            <!--<router-link to="/personalCenter/fileUploading" tag="li" class="personal-center__nav-list-item&#45;&#45;file-uploading">-->

            <!--资料附件上传-->
            <!--</router-link>-->

            <router-link to="/personalCenter/realNameAuth"
                         tag="li"
                         v-if="Number(userInfo.crmCustomerType)"
                         class="personal-center__nav-list-item--real-name-auth">
              <span v-if="Number(userInfo.crmCustomerType) === 1">
                实名认证
                <!-- <i class="red-point"></i> -->
              </span>
              <span v-if="Number(userInfo.crmCustomerType) === 2">
                企业认证
                <!-- <i class="red-point"></i> -->
              </span>
            </router-link>
            <router-link to="/personalCenter/message"
                         tag="li"
                         :class="['personal-center__nav-list-item--mes',$route.meta.name === 'messagedetails' ? 'active' : '']">
              消息
              <!-- <i class="red-point"></i> -->
            </router-link>
            <router-link to="/personalCenter/workOrder"
                         tag="li"
                         :class="['personal-center__nav-list-item--dongdan',$route.meta.name === 'workOrderDetails' ? 'active' : '']">
              工单咨询
              <!-- <i class="red-point"></i> -->
            </router-link>
            <router-link to="/personalCenter/updatePassword"
                         tag="li"
                         class="personal-center__nav-list-item--update-password">
              修改密码
              <!-- <i class="red-point"></i> -->
            </router-link>
          </ul>
        </nav>
        <div class="home-page-model">
          <div class="backPage" v-if="pageBack" @click="goback">
            <img class="tip" src="./../assets/images/icon_back@2x.png" alt="">
            <a class="tip-back" href="#">返回</a>
          </div>
          <router-view class="personal-center__router-view" v-on:testClick2="testClick2" v-on:testClick="testClick" v-bind:mainCount="mainCount" v-bind:singleCount="singleCount">
        </router-view>
        </div>
      </section>
    </div>
  </div>

</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import * as types from '../vuex/types';
import checkNumApi from '@/api/projectContract.js';

export default {
  data () {
    return {
      mainCount: '',
      singleCount: '',
      pageBack: false,
      screenHeight: document.body.clientHeight
    };
  },
  computed: {
    ...mapGetters({
      userInfo: types.GET_USER
    })
  },
  created () {
    this.checkNumtip();
  },
  mounted () {
    // 当不存在crmCustomerType跳转至登录页面
    if (!Number(this.userInfo.crmCustomerType)) {
      this.$router.push('/login');
    }
  },
  watch: {
   // 监视路由，参数为要目标路由和当前页面的路由
    '$route': function (to, from) {
      if (
         [
           '/myLoan_bl',
           '/personalCenter/myLoan_bl/loanLists_bl',
           '/personalCenter/myLoan_bl',
           '/loanDetail_bl_pool',
           '/personalCenter/myBill',
           '/personalCenter/myBill',
           '/personalCenter/mainProjectContractList',
           '/personalCenter/blLoanContract/list',
           '/personalCenter/transferAdvice/list',
           '/personalCenter/repoNotice/list',
           '/personalCenter/myInfo',
           '/personalCenter/bankcardInfo',
           '/personalCenter/realNameAuth',
           '/personalCenter/message',
           '/personalCenter/workOrder',
           '/personalCenter/updatePassword'
         ].includes(to.path)
       ) {
        this.pageBack = false;
      } else {
        this.pageBack = true;
      }
    }
  },

  methods: {
    testClick (msg) {
      this.singleCount = msg;
    },
    testClick2 (msg2) {
      this.mainCount = msg2;
    },
    checkNumtip () {
      checkNumApi.checkNum({
        tokenId: localStorage.getItem('dl_tokenId_bl')
      }).then((res) => {
        if (res.data.code == 0) {
          this.mainCount = res.data.result.mainCount;
          this.singleCount = res.data.result.singleCount;
          this.payCount = res.data.result.payCount;
        } else {
        }
      }).catch((err) => {
        console.log('err', err);
      });
    },
    ...mapMutations({
      setActiveName: types.SET_ACTIVE_NAME
    }),
    ...mapActions({
      getRealNameAuthData: types.GET_REAL_NAME_AUTH_DATA,
      setSuccessMessage: types.SET_SUCCESS_MESSAGE,
      setFailMessage: types.SET_FAIL_MESSAGE
    }),
    setActive () {
      this.setActiveName('2');
    },
    goback () {
      this.$router.go(-1);
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath);
    },
    checkRealNameAuth () {
      this.getRealNameAuthData({
        token: this.userInfo.token,
        crmCustomerType: this.userInfo.crmCustomerType
      }).then((res) => {
        if (Number(this.userInfo.crmCustomerType) === 1) { // 个人
	          const data = res.data;
	          if (Number(data.code) === 0 || Number(data.code) === 3) {
	            if (Number(data.result.isAuth) != 1) { // 未实名认证
              this.setFailMessage({
	                  show: true,
	                  content: '请先进行实名认证'
	                });
	            	this.$router.push({path: '/personalCenter/realNameAuth'});
	            }
	          }
        } else if (Number(this.userInfo.crmCustomerType) === 2) { // 企业
	          const result = res.data;
	          const data = res.data.data;
	          if (Number(result.code) === 0 || Number(result.code) === 3 || Number(result.code) === 2) {
	            if (Number(data.payReqEntity.isAuth) !== 1) { // 未实名认证
              this.setFailMessage({
	                  show: true,
	                  content: '请先进行实名认证'
	                });
	            	this.$router.push({path: '/personalCenter/realNameAuth'});
	            }
	          }
        }
      });
    }
  }
};
</script>
<style lang="scss">
.oy-center-container {
  background: #f5f7f8;
}
.home-page-model{
  display: flex;
  flex-direction: column;
  .backPage{
    width: 100px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 250px;
    .tip {
      width: 9px;
      height: 13px;
    }
    .tip-back{
      margin-left: 5px;
      font-size: 18px;
      color: #ccc;
    }
  }
}
.oy-center-container::-webkit-scrollbar {
  width: 0;
  height: 0;
  opacity: 0;
}
@mixin personalCenterNavLi {
  // height: 50px;
  line-height: 50px;
  font-size: 16px;
  font-family: "FZLanTingHei-DB-GBK";

  &:before {
    content: "";
    display: inline-block;
    margin: 0 9px 0 40px;
    vertical-align: -8px;
    width: 28px;
    height: 28px;
  }

  &.active {
    background: rgba(255, 193, 150, 0.5);

  }
}

.personal-center-container {
  height: 100%;
  min-height: 900px;
}

.personal-center {
  @include clear;
  position: relative;
  margin: 0 auto;
  width: $containerWidth;
  min-height: 100%;
  /*min-height: 648px;*/
}

.personal-center__nav {
  @include clear;
  float: left;
  position: absolute;
  width: 250px;
  height: 100%;
  min-height: 900px;
  color: #333333  ;
  background: #fff;
}

.personal-center__nav-list {
  padding: 20px 0;
  li:hover {
    cursor: pointer;
  }
}
.personal-center__nav-list>li:hover {
  background: rgba(255, 193, 150, 0.5);
}
.personal-center__nav-list .hover-col .el-submenu>div:hover {
  background: rgba(255, 193, 150, 0.5);
}
.personal-center__nav-list .hover-col .el-submenu ul>li:hover {
  background: rgba(255, 193, 150, 0.5);
}

.personal-center__nav-list-item--my-loan {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/icons/icon_money.png") no-repeat;
        margin-bottom: -3px;
  }
}
.personal-center__nav-list-item--my-loan_bl {
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/wdbl_mr.png") no-repeat;
        margin-bottom: -3px;
  }
}
.personal-center__nav-list-item--my-loan_bl.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/wdbl_xz.png") no-repeat;
        margin-bottom: -3px;
  }
}
.personal-center__nav-list-item--my-bill {
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/wdpz_mr.png") no-repeat;
        margin-bottom: -3px;
  }
}
.personal-center__nav-list-item--my-bill.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/wdpz_xz.png") no-repeat;
        margin-bottom: -3px;
  }
}
.personal-center__nav-list-item--my-info {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/qyxx_mr.png") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--my-info.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/qyxx_xz.png") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--contract {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/yszktzs_mr.png") no-repeat;
        margin-bottom: -1px;
  }
}
.personal-center__nav-list-item--contract2 {
  color: #333333;
      margin-left: -40px;
      line-height: 50px;
  font-size: 16px;
  font-family: "FZLanTingHei-DB-GBK";
 
}
.personal-center__nav-list-item--contract2.active {
  color: #EB662B;
   background: rgba(255, 193, 150, 0.5);
  margin-left: -40px;
      line-height: 50px;
  font-size: 16px;
  font-family: "FZLanTingHei-DB-GBK";

}
.personal-center__nav-list-item--contract.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/yszktzs_xz.png") no-repeat;
        margin-bottom: -1px;
  }
}
.personal-center__nav-list-item--bankcard-info {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/yhkxx_mr.png") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--bankcard-info.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/yhkxx_xz.png") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--file-uploading {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/icons/icon_upload.png") no-repeat;
        margin-bottom: -3px;
  }
}

.personal-center__nav-list-item--real-name-auth {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/qyxx_mr.png") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--real-name-auth.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../assets/images/qyxx_xz.png") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--mes {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/msgm.jpg") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--mes.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/msgl.png") no-repeat;
        margin-bottom: -7px;
  }
}
.personal-center__nav-list-item--dongdan {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/gongdanm.png") no-repeat;
        margin-bottom: -3px;
  }
}
.personal-center__nav-list-item--dongdan.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/gongdanl.png") no-repeat;
        margin-bottom: -3px;
  }
}

.personal-center__nav-list-item--update-password {
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/xgmm_mr.png") no-repeat;
        margin-bottom: -3px;
  }
}

.personal-center__router-view {
  margin-left: 250px;
  min-height: 100%;
}

.personal-center__nav-list-item--update-password.active {
  color: #EB662B;
  @include personalCenterNavLi;
  &:before {
    background: url("../../static/images/xgmm_xz.png") no-repeat;
        margin-bottom: -3px;
  }
}
.red-point {
    background: #f00;
    border-radius: 50%;
    width: 8px;
    height: 8px;
        display: inline-block;
   
  }
  .el-submenu [class^=el-icon-] {
    vertical-align: middle;
    margin-right: -48px;
    width: 24px;
    text-align: center;
}
// .el-menu-item.is-active, .el-menu-item.is-active {
//     color: #EB662B;

// }
.el-menu {
    border-radius: 2px;
    list-style: none;
    position: relative;
    margin: 0;
    padding-left: 0;
    background-color: #fff;
}
.el-submenu .el-menu-item:hover, .el-submenu__title:hover {
    background: #fff;
}
.el-submenu .el-menu {
    background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// PersonalCenter.vue?6901fca0